import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import _ from "lodash";
import {
  Table,
  Button,
  Popconfirm,
  Empty,
  Pagination,
  Tooltip,
  Alert,
  Modal
} from "antd";
import ModalProduct from "../../modalProduct";
import DrawerFilter from "./drawerFilter";
import DrawerClassify from "./drawerClassify";
import Loading from "../../../../components/Loading";
import { getProduct, deleteProduct } from "../actions";
import { getProducts as getProductsIcms } from "../Icms/actions";
import { getProducts, classifySuggestion } from "./actions";
import { exportarProdutos } from "./actions";
import { createLoadingSelector } from "../../../../store/api/selectors";
import { maskNcm, dateToEnglish } from "../../../../helpers/functions";
import { clearProductsIcms } from "../../Classify/Icms/actions";
import { clearProductsPisCofings } from "../../Classify/PisCofins/actions";
import { ExclamationCircleOutlined } from '@ant-design/icons';

const { confirm } = Modal;

const columns = [
  {
    title: "Código do Item",
    dataIndex: "CodigoProduto",
    width: 150,
    sorter: true,
  },
  {
    title: "Descrição",
    dataIndex: "Descricao",
    sorter: true,
  },
  {
    title: "NCM",
    dataIndex: "Ncm",
    width: 80,
    sorter: true,
    render: (text, record) => maskNcm(record.Ncm),
  },
  {
    title: "EX",
    dataIndex: "Ex",
    width: 60,
    align: "center",
    sorter: true,
  },
  {
    title: "EAN",
    dataIndex: "Ean",
    width: 120,
    sorter: true,
  },
  {
    title: (
      <img
        style={{ height: "16px" }}
        src="https://images.e-auditoria.com.br/global/logos/svg/econsulta-white.svg"
        alt="e-Consulta"
      />
    ),
    dataIndex: "DescricaoTributoNcm",
    width: 230,
    render: (text, record) => (
      <>
        <a
          className={`mr-2 ${record.DescricaoTributacao === "NCM NÃO ENCONTRADA" ||
            record.DescricaoTributacao === "-"
            ? "invisible"
            : "visible"
            }`}
          href={`https://econsulta.e-auditoria.com.br/Home/ConsultaRecuperador?id=${record.Ncm}&tc=PISCOFINS`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fas fa-search" />
        </a>
        {record.DescricaoTributacao}
      </>
    ),
  },
  {
    title: "Trib. Considerada",
    dataIndex: "Classificacao",
    width: 150,
    align: "center",
    render: (text, record) => {
      let classificacaoVigente = record.Classificacao.filter((c) => {
        if (c.Vigente) {
          return c;
        }
        return null;
      });
      if (classificacaoVigente[0]) {
        return <>{classificacaoVigente[0].DescricaoTributacao}</>;
      }
      return "-";
    },
  },
];

const initialState = {
  sizePage: 50,
  visibleModal: false,
  visibleEdit: false,
  visibleDelete: false,
  visibleClassify: false,
  isEdit: false,
  selectedAll: false,
  selectedRowKeys: [],
  selectedBaseNcm: null,
  selectedClassified: null,
  selectedCurrent: null,
  filter: {
    sCodigoProduto: null,
    sDescricao: null,
    sNcm: null,
    sEx: null,
    sEan: null,
    sBaseNcm: 0,
    sClassificacaoFinal: 0,
    sBaseClassificacaoUsuario: 0,
    sClassificado: null,
    sDuplicado: null,
    sPeriodo: null,
    sorter: null,
  },
  dropdown: {
    vazioEX: false,
  },
  filterStr: "",
  isDuplicated: false,
  isExport: false,
};

class GridClassify extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...initialState,
      pageNumber: 1,
      paginationStr: "",
      visibleDrawerFilter: false,
      visibleDrawerClassify: false,
      editClassify: false,
      listPeriod: [],
      itemFilter: "",
      extraData: {
        month: null,
        year: null,
        status: null,
      },
      useData: [],
      canEditClassify: false,
      isExport: false,
    };

    this.handleReset = this.handleReset.bind(this);
    this.visibleModal = this.visibleModal.bind(this);
    this.visibleActions = this.visibleActions.bind(this);
    this.deleteProduct = this.deleteProduct.bind(this);
  }

  componentDidMount() {
    const {
      props,
      props: { productsPis },
    } = this;
    const { sizePage, useData } = this.state;

    if (!productsPis || (productsPis && !productsPis.length)) {
      this.setState(
        { paginationStr: `?pageNumber=1&pageSize=${sizePage}&filter=` },
        () => {
          const { filterStr } = this.state;
          props.getProducts(filterStr);
        }
      );
    } else if (useData !== productsPis) {
      const tempData =
        productsPis &&
        productsPis.map((p) => {
          return {
            ...p,
            Ncm: p.Ncm || "",
            Ex: p.Ex || "",
          };
        });
      this.setState({ useData: tempData });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { selectedRowKeys, selectedAll } = this.state,
      { productsPis, period, statusError } = this.props,
      { cnpj } = this.props.match.params;

    if (prevState.selectedRowKeys !== selectedRowKeys) {
      this.visibleActions();
      this.visibleClassify();
    }

    if (prevProps.match.params.cnpj !== cnpj) {
      this.handleReset();
    }

    if (prevProps.productsPis !== productsPis) {
      const useData =
        productsPis &&
        productsPis.map((p) => {
          return {
            ...p,
            Ncm: p.Ncm || "",
            Ex: p.Ex || "",
          };
        });
      this.setState({ useData });

      if (selectedAll) {
        this.onSelect(selectedAll);
      }

      if (!productsPis && statusError) {
        this.setState({
          extraData: {
            month: null,
            year: null,
            status: null,
          },
        });
        this.props.changeActiveTab("4");
        this.props.getProducts();
      } else {
        this.setState({
          extraData: {
            month: period && period.Mes,
            year: period && period.Ano,
            status: statusError,
          },
        });
      }
    }
  }

  componentWillUnmount() {
    clearProductsPisCofings();
    clearProductsIcms();
  }

  handleDropdownEX = (value) => {
    const vazio = value === "Vazio" ? true : false;
    this.setState({
      dropdown: {
        ...this.state.dropdown,
        vazioEX: vazio,
      },
      filter: {
        ...this.state.filter,
        sEx: vazio ? null : this.state.filter.sEx,
      },
    });
  };

  handleReset() {
    this.setState({ ...initialState });
    this.props.getProducts();
  }

  visibleModal = (isEdit) => {
    const { visibleModal, selectedRowKeys } = this.state;

    this.setState(
      {
        visibleModal: !visibleModal,
        isEdit: isEdit,
      },
      async () => {
        if (isEdit) {
          await this.props.getProduct(selectedRowKeys[0]);
        }
      }
    );
  };

  visibleActions() {
    const { selectedRowKeys } = this.state;
    const quantity = selectedRowKeys.length;

    if (!quantity) {
      this.setState({
        visibleEdit: false,
        visibleDelete: false,
      });
    } else if (quantity) {
      this.setState({
        visibleEdit: true,
        visibleDelete: true,
      });

      if (quantity > 1) {
        this.setState({
          visibleEdit: false,
        });
      }
    }
  }

  visibleClassify() {
    const { selectedRowKeys } = this.state;
    if (selectedRowKeys.length > 0) {
      this.setState({ visibleClassify: true });
    } else {
      this.setState({ visibleClassify: false });
    }
  }

  deleteProduct = async () => {
    const { selectedRowKeys, selectedAll, filterStr, extraData } = this.state;

    if (selectedAll) {
      await this.props.deleteProduct(
        null,
        extraData,
        filterStr ? `?filter=${filterStr}&todos=true` : "?todos=true"
      );
      this.handleReset();
    } else {
      await this.props.deleteProduct(selectedRowKeys, extraData, "");
      this.handleFilters(true);
    }
  }

  classifySuggestion = async () => {
    const { filterStr, selectedAll, selectedRowKeys, extraData } = this.state;
    let data = {};

    if (!selectedAll) {
      data.Ids = selectedRowKeys;
      await this.props.classifySuggestion(data, `?filter=${filterStr}`, extraData);
    } else {
      await this.props.classifySuggestion(
        data,
        filterStr ? `?filter=${filterStr}&todos=true` : "?todos=true",
        extraData
      );
    }

    this.handleFilters();
  };

  changePage = (page) => {
    const { filterStr, sizePage, extraData, isDuplicated } = this.state;

    this.setState(
      {
        paginationStr: `?pageNumber=${page}&pageSize=${sizePage}&filter=${filterStr}`,
        pageNumber: page,
      },
      () => {
        this.props.getProducts(
          this.state.paginationStr,
          extraData,
          isDuplicated
        );
      }
    );
  };

  changeSizePage = (current, size) => {
    const { filterStr, extraData } = this.state;

    this.setState(
      {
        sizePage: size,
        paginationStr: `?pageNumber=${current}&pageSize=${size}&filter=${filterStr}`,
      },
      () => {
        this.props.getProducts(this.state.paginationStr, extraData);
      }
    );
  };

  onSelectChange = (selectedRowKeys, selectedRows) => {
    const { cnpj } = this.props.match.params;
    let canEditClassify = this.state.canEditClassify;
    let itemFilter = "";

    if (selectedRows.length) {
      canEditClassify = _.every(selectedRows, {
        Ncm: selectedRows[0].Ncm,
        Ex: selectedRows[0].Ex,
      });

      if (canEditClassify) {
        itemFilter = selectedRows.length
          ? `Ncm=${selectedRows[0].Ncm}&Ex=${selectedRows[0].Ex}&Cnpj=${cnpj}`
          : "";
      }
    }

    this.setState({ selectedRowKeys, canEditClassify, itemFilter });
  };

  handleFilters = async (afterDeleteProduct = false) => {
    const { filter, isDuplicated, sizePage, extraData } = this.state;
    let newFilter = { ...filter };
    let filterStr = "";

    await this.setState({
      visibleModal: false,
      visibleEdit: false,
      visibleDelete: false,
      visibleClassify: false,
      isEdit: false,
      selectedAll: false,
      selectedRowKeys: [],
    });

    if (newFilter.sNcm === "") {
      newFilter = {
        ...newFilter,
        sNcm: null,
      };
    }

    const { dropdown } = this.state;

    Object.keys(newFilter).map((item) => {
      if (newFilter[item]) {
        const separador = filterStr ? "|" : "";
        if (item === "sEx") {
          const ex = filter[item];
          filterStr =
            ex !== "=" && !dropdown.vazioEX
              ? filterStr + separador + item + ex
              : filterStr;
          filterStr = dropdown.vazioEX
            ? filterStr + separador + item + "="
            : filterStr;
        } else {
          filterStr =
            newFilter[item] !== "="
              ? filterStr + separador + item + newFilter[item]
              : filterStr;
        }
      } else {
        if (item === "sEx" && dropdown.vazioEX) {
          filterStr = filterStr
            ? filterStr + "|" + item + "="
            : filterStr + item + "=";
        }
      }
      filterStr = filterStr.replace("sorter", "");
      return filterStr;
    });

    this.setState(
      {
        filterStr: filterStr,
        paginationStr: `?pageNumber=1&pageSize=${sizePage}&filter=`,
      },
      () => {
        filterStr = this.state.paginationStr + filterStr;
        this.props.getProducts(filterStr, extraData, isDuplicated);
        if(afterDeleteProduct) this.props.getProductsIcms(filterStr, extraData, isDuplicated);
      }
    );

    if (newFilter.sPeriodo) {
      columns[5].className = "d-none";
    } else {
      columns[5].className = "";
    }

    this.setState({ filter: newFilter });
  };

  handleChangeSorter = (pagination, filters, sorter) => {
    const order = sorter.order === "ascend" ? 0 : 1;

    this.setState(
      {
        filter: {
          ...this.state.filter,
          sorter: sorter.field ? "o" + sorter.field + "=" + order : "",
        },
      },
      () => {
        this.handleFilters();
      }
    );
  };

  handleChangeField = (e, field) => {
    let value, name;

    if (e === "Periodo") {
      value = dateToEnglish(field);
      name = e;

      if (!value) {
        this.setState((state) => ({
          selectedCurrent: null,
          filter: {
            ...state.filter,
            sBaseClassificacaoUsuario: 0,
          },
        }));
      } else {
        this.setState((state) => ({
          selectedBaseNcm: null,
          filter: {
            ...state.filter,
            sBaseNcm: 0,
          },
        }));
      }
    } else {
      value = field ? e : e.target.value;
      name = field ? field : e.target.name;

      if (name === "Ncm") {
        value = value.split(".").join("");
      }
    }

    this.setState((state) => ({
      filter: {
        ...state.filter,
        ["s" + name]: value !== null ? `=${value}` : null,
      },
    }));

    if (field === "BaseNcm") {
      this.setState({ selectedBaseNcm: value });
    } else if (field === "ClassificacaoFinal") {
      this.setState({ selectedClassified: value });
    } else if (field === "BaseClassificacaoUsuario") {
      this.setState({ selectedCurrent: value });
    }
  };

  handleClickFilter = (e) => {
    const id = e.target.id,
      value = e.target.value;

    if (id === "sDuplicado" && value === "=1") {
      this.setState((prevState) => ({
        filter: {
          ...prevState.filter,
          sClassificado: null,
        },
        isDuplicated: true,
      }));
    } else {
      this.setState((prevState) => ({
        filter: {
          ...prevState.filter,
          sDuplicado: null,
        },
        isDuplicated: false,
      }));
    }

    this.setState(
      (prevState) => ({
        filter: {
          ...prevState.filter,
          [id]: value,
        },
      }),
      () => this.handleFilters()
    );
  };

  handleClickExport = () => {
    const { filterStr, selectedAll, selectedRowKeys, extraData } = this.state;
    let data = {};

    if (!selectedAll) {
      this.setState({ isExport: true });
      data.Ids = selectedRowKeys;
      this.props.exportarProdutos(data, `?filter=${filterStr}`, extraData);
    } else {
      this.setState({ isExport: true });
      this.props.exportarProdutos(
        data,
        filterStr ? `?filter=${filterStr}&todos=true` : "?todos=true",
        extraData
      );
    }

    this.setState({ isExport: false });
  };

  onSelect = (selectedAll) => {
    const { productsPis } = this.props;
    const { useData } = this.state;
    const { cnpj } = this.props.match.params;
    let canEditClassify = this.state.canEditClassify;
    let itemFilter = "";

    if (useData.length) {
      canEditClassify = _.every(useData, {
        Ncm: useData[0].Ncm,
        Ex: useData[0].Ex,
      });

      if (canEditClassify) {
        itemFilter = `Ncm=${useData[0].Ncm}&Ex=${useData[0].Ex}&Cnpj=${cnpj}`;
      }
    }

    if (!selectedAll) {
      this.setState((prevState) => ({
        selectedRowKeys: !prevState.selectedAll
          ? productsPis && productsPis.map((item) => item.Id)
          : [...Array(0).keys()],
        selectedAll: !prevState.selectedAll,
        canEditClassify,
        itemFilter,
      }));
    } else {
      this.setState({
        selectedRowKeys: productsPis && productsPis.map((item) => item.Id),
        canEditClassify,
        itemFilter,
      });
    }
  };

  onSelectRow = (record, selected, selectedRows) => {
    const endClassify = record.Classificacao.length > 0 ? true : false;

    if (selectedRows.length === 1) {
      if (endClassify) {
        this.setState({
          editClassify: true,
          listPeriod: selectedRows[0].Classificacao,
        });
      } else {
        this.setState({
          listPeriod: [],
        });
      }
      this.setState({ isRevenue: selectedRows[0].ConsiderarReceita });
    } else {
      this.setState({
        editClassify: false,
        listPeriod: [],
        isRevenue: !selectedRows.every((item) => !item.ConsiderarReceita),
      });
    }
  };

  showDrawer = (name) => {
    this.setState({ [name]: true });
  };

  onClose = (name, clear) => {
    this.setState((state) => ({
      [name]: false,
      selectedAll: false,
      selectedRowKeys: clear ? [] : state.selectedRowKeys,
      editClassify: false,
      listPeriod: [],
      itemFilter: "",
    }));
  };

  exitEditDivergence = () => {
    this.setState(
      {
        extraData: {
          month: null,
          year: null,
          status: null,
        },
      },
      () => this.props.getProducts()
    );
  };

  renderButtonDivergence = () => {
    const { statusError } = this.props;
    if (statusError) {
      switch (statusError) {
        case 4:
          return (
            <Button
              className="btn-divergence"
              type="danger"
              onClick={this.exitEditDivergence}
            >
              Sair da edição de duplicidade
            </Button>
          );
        default:
          return (
            <Button
              className="btn-divergence"
              type="danger"
              onClick={this.exitEditDivergence}
            >
              Sair da edição de pendência
            </Button>
          );
      }
    }
    return null;
  };

  handlerEnabledComponent = (condition, view) => {
    if (condition) {
      return view;
    }
    return null;
  };

  showDeleteConfirm() {
    confirm({
      title: 'ATENÇÃO',
      icon: <ExclamationCircleOutlined />,
      content: 'A exclusão de um ou mais itens, após o processamento dos cálculos, poderá interferir nos resultados gerados, caso esse(s) item(s) tenha(m) sido movimentados em suas saídas. Tem certeza que deseja prosseguir? ',
      okText: 'Sim',
      okType: 'danger',
      cancelText: 'Cancelar',
      onOk: () => {
        this.deleteProduct();
      },
      onCancel() { },
    });
  }

  renderButtonExport(sBaseNcm) {
    const { isProcessando } = this.props;
    const { filter, isExport } = this.state;

    if (
      (sBaseNcm === "=4" || sBaseNcm === 0 || sBaseNcm === null) &&
      filter.sPeriodo === null
    ) {
      return (
        <Popconfirm
          title="Exportar itens para revisão?"
          okText="Sim"
          cancelText="Não"
          onConfirm={this.handleClickExport}
        >
          <Tooltip
            placement="bottom"
            title={
              isProcessando
                ? "Funcionalidade desabilitada por ter documentos em processamento"
                : "Exporta todos os itens para que seja feita a revisão de códigos NCM. Ao final, você poderá importar essa planilha novamente para o sistema e atualizar seu cadastro."
            }
          >
            <Button
              className="ml-1"
              type="primary"
              loading={isExport}
              disabled={isProcessando}
              ghost
            >
              Exportar itens para revisão de NCM
            </Button>
          </Tooltip>
        </Popconfirm>
      );
    } else {
      return null;
    }
  }

  render() {
    const {
      product,
      productsPis,
      paging,
      total,
      statusError,
      isFetching,
      isProcessando,
    } = this.props;
    const {
      sizePage,
      filter,
      visibleModal,
      visibleEdit,
      visibleDelete,
      visibleClassify,
      isEdit,
      selectedAll,
      selectedRowKeys,
      visibleDrawerFilter,
      visibleDrawerClassify,
      editClassify,
      filterStr,
      listPeriod,
      isRevenue,
      itemFilter,
      useData,
      canEditClassify,
    } = this.state;

    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
      hideDefaultSelections: true,
      selections: [
        {
          key: "all-data",
          text: "Selecionar todos",
          onSelect: () => this.onSelect(),
        },
      ],
      onSelect: this.onSelectRow,
      getCheckboxProps: () => ({
        disabled: selectedAll,
      }),
      onSelection: this.onSelection,
      fixed: true,
      columnWidth: 50,
    };

    return (
      <>
        {isFetching ? <Loading text="Carregando produtos" /> : null}

        {visibleModal ? (
          <ModalProduct
            visible={visibleModal}
            visibleModal={this.visibleModal}
            handleFilters={this.handleFilters}
            product={product}
            isEdit={isEdit}
            changePage={(page) => this.setState({ pageNumber: page })}
          />
        ) : null}

        {visibleDrawerFilter ? (
          <DrawerFilter
            {...this.state}
            visibleDrawer={visibleDrawerFilter}
            handleChangeField={this.handleChangeField}
            handleFilters={this.handleFilters}
            handleReset={this.handleReset}
            onClose={this.onClose}
            handleDropdownEX={this.handleDropdownEX}
          />
        ) : null}

        {visibleDrawerClassify ? (
          <DrawerClassify
            {...this.state}
            visibleDrawer={visibleDrawerClassify}
            listPeriod={listPeriod}
            itemFilter={itemFilter}
            canEditClassify={canEditClassify}
            isRevenue={isRevenue}
            handleReset={this.handleReset}
            onClose={this.onClose}
          />
        ) : null}

        {productsPis?.length ? (
          <>
            {this.handlerEnabledComponent(
              (total && total.FiltroDuplicados) ||
              (statusError && statusError > 0),
              <Alert
                className="mb-2"
                showIcon={true}
                message="A edição do item não irá alterar os resultados já gerados. Caso queira que a edição do item modifique os resultados anteriores ou posteriores, você terá que reprocessar as competências desejadas."
                type="warning"
              />
            )}
            <div className="products__actions">
              <div className="products__actions___filters">
                {visibleClassify ? (
                  <span className="mt-1 mr-2">
                    {`${selectedAll ? paging.TotalItems : selectedRowKeys.length
                      } selecionado(s)`}
                  </span>
                ) : null}

                {this.handlerEnabledComponent(
                  statusError !== 4 && statusError !== 3,
                  <>
                    <Button
                      className={
                        filter.sClassificado === "=0"
                          ? "btn btn--active"
                          : "btn"
                      }
                      id="sClassificado"
                      value="=0"
                      disabled={total && !total.NaoClassificado}
                      onClick={this.handleClickFilter}
                    >
                      {total && total.NaoClassificado + " não classificados"}
                    </Button>
                  </>
                )}

                {this.handlerEnabledComponent(
                  statusError !== 4 && statusError !== 3,
                  <>
                    <Button
                      className={
                        filter.sClassificado === "=1"
                          ? "btn btn--active"
                          : "btn"
                      }
                      id="sClassificado"
                      value="=1"
                      disabled={total && !total.Classificados}
                      onClick={this.handleClickFilter}
                    >
                      {total && total.Classificados + " classificados"}
                    </Button>
                  </>
                )}

                {this.handlerEnabledComponent(
                  statusError !== 4 && statusError !== 3,
                  <>
                    {total && total.ItensDuplicados ? (
                      <Button
                        className={
                          filter.sDuplicado === "=1" ? "btn btn--active" : "btn"
                        }
                        id="sDuplicado"
                        value="=1"
                        disabled={total && !total.ItensDuplicados}
                        onClick={this.handleClickFilter}
                      >
                        {total && total.ItensDuplicados + " itens duplicados"}
                      </Button>
                    ) : null}
                  </>
                )}

                {(!total?.FiltroDuplicados || !statusError) &&
                  this.renderButtonExport(this.state.filter.sBaseNcm)}

                {visibleEdit ? (
                  <Tooltip title="Editar produto">
                    <Button
                      className="btn"
                      icon="edit"
                      loading={isFetching || isProcessando}
                      onClick={() => this.visibleModal(true)}
                    />
                  </Tooltip>
                ) : null}

                {visibleDelete ? (
                  <Button className="btn btn-hover-danger" icon="delete" disabled={isFetching || isProcessando} onClick={() => this.showDeleteConfirm()} />
                ) : null}
              </div>
              <div>
                {visibleClassify ? (
                  <>
                    <Popconfirm
                      title="Confirmar classificação pela indicação do e-Consulta?"
                      okText="Sim"
                      cancelText="Não"
                      onConfirm={this.classifySuggestion}
                      disabled={isFetching || isProcessando}
                    >
                      <Button className="btn" type="primary" ghost>
                        Classificar conforme e-Consulta
                      </Button>
                    </Popconfirm>

                    <Button
                      className="btn"
                      type="primary"
                      ghost
                      onClick={() => this.showDrawer("visibleDrawerClassify")}
                      disabled={isFetching || isProcessando}
                    >
                      {!editClassify
                        ? "Classificar manualmente"
                        : "Editar classificação"}
                    </Button>
                  </>
                ) : null}

                <Tooltip title="Filtrar">
                  <Button
                    className="btn"
                    icon="filter"
                    onClick={() => this.showDrawer("visibleDrawerFilter")}
                  />
                </Tooltip>

                {this.renderButtonDivergence()}

                {total && total.FiltroDuplicados ? (
                  <Button
                    className="btn-divergence"
                    type="danger"
                    onClick={() => this.props.getProducts()}
                  >
                    Sair da edição de duplicidade
                  </Button>
                ) : null}
              </div>
            </div>

            <Table
              className="ant-table--custom noselect"
              dataSource={useData}
              rowKey={(record) => record.Id}
              columns={columns}
              scroll={{
                x: 1100,
                y:
                  (total && total.FiltroDuplicados) || statusError > 0
                    ? "calc(100vh - 430px)"
                    : "calc(100vh - 360px)",
              }}
              pagination={false}
              rowSelection={rowSelection}
              onChange={this.handleChangeSorter}
              onSelectAll={this.handleSelectAll}
            />

            {paging ? (
              <Pagination
                className="pagination-classify mt-3"
                showSizeChanger
                pageSizeOptions={["10", "50", "100"]}
                current={this.state.pageNumber}
                defaultPageSize={sizePage}
                pageSize={sizePage}
                defaultCurrent={1}
                total={paging.TotalItems}
                showTotal={(total, range) =>
                  `${range[0]}-${range[1]} de ${total} itens`
                }
                onChange={this.changePage}
                onShowSizeChange={this.changeSizePage}
              />
            ) : null}

            <Button
              className="btn-new-product"
              type="primary"
              shape="circle"
              icon="plus"
              size="large"
              onClick={() => this.visibleModal(false)}
              disabled={isFetching || isProcessando}
            />
          </>
        ) : (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="Nenhum produto para mostrar"
          >
            <Button
              className="btn-new-product"
              type="primary"
              shape="circle"
              icon="plus"
              size="large"
              onClick={() => this.visibleModal(false)}
              disabled={isFetching || isProcessando}
            />

            {filterStr !== "" ? (
              <Button
                className="btn"
                icon="filter"
                onClick={() => this.showDrawer("visibleDrawerFilter")}
              >
                Filtrar
              </Button>
            ) : null}
          </Empty>
        )}
      </>
    );
  }
}

const loadingGetProducts = createLoadingSelector(["GET_PISCOFINS"]),
  loadingClassifyProduct = createLoadingSelector([
    "CLASSIFY_PRODUCT_PISCOFINS",
  ]),
  loadingClassifySuggestion = createLoadingSelector([
    "CLASSIFY_SUGGESTION_PISCOFINS",
  ]),
  loadingPutClassify = createLoadingSelector(["PUT_CLASSIFY_PISCOFINS"]),
  loadingDeleteProduct = createLoadingSelector(["DELETE_PRODUCT"]),
  loadingExportarProdutos = createLoadingSelector(["EXPORTAR_PRODUTOS"]);

const mapStateToProps = (state) => ({
  product: state.products.data.Retorno || {},
  productsPis: state.pisCofins.list,
  paging: state.pisCofins.paging,
  total: state.pisCofins.total,
  period: state.pisCofins.period,
  statusError: state.pisCofins.statusError,
  isProcessando: state.importacao.isProcessando,
  isFetching:
    loadingGetProducts(state) ||
    loadingClassifyProduct(state) ||
    loadingClassifySuggestion(state) ||
    loadingPutClassify(state) ||
    loadingDeleteProduct(state) ||
    loadingExportarProdutos(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getProduct,
      getProducts,
      getProductsIcms,
      deleteProduct,
      classifySuggestion,
      exportarProdutos,
      clearProductsPisCofings, clearProductsIcms
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(GridClassify));
